/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateColumnPresetMutationRequest,
  CreateColumnPresetMutationResponse,
  CreateColumnPreset400,
} from '../types/CreateColumnPreset'

function getCreateColumnPresetUrl() {
  const res = { method: 'POST', url: `/api/v1/column-presets/` as const }
  return res
}

/**
 * @summary Create a new column preset
 * {@link /api/v1/column-presets/}
 */
export async function createColumnPreset(
  data: CreateColumnPresetMutationRequest,
  config: Partial<RequestConfig<CreateColumnPresetMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateColumnPresetMutationResponse,
    ResponseErrorConfig<CreateColumnPreset400>,
    CreateColumnPresetMutationRequest
  >({
    method: 'POST',
    url: getCreateColumnPresetUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
